function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { SafeAreaView, StatusBar, Platform } from 'react-native';
import { Flex } from 'components/base/General';
import { Stack, XStack, useTheme, SizableText } from 'tamagui';
import SideMenu from './FauxSidebar';
import { openSideBar } from 'reducers/slices/sidebar';
import { useColorModeValue } from 'utils/hooks';
import { useSelector, useDispatch } from 'react-redux';
import Header from 'components/header/Header';
import loadable from '@loadable/component';
import Footer from 'components/main/Footer';
import { usePathname } from 'solito/navigation';
import { useGetArticleBySlugQuery } from 'utils/RTKGraphQL';
import Loading from 'components/utility/Loading';
const Menu = loadable(() => import('components/main/sidebar/Menu'));
const ArticleControls = loadable(() => import('components/main/ArticleControls'));
const GeneralStatusBarColor = ({
  backgroundColor,
  height,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(SafeAreaView, {
    style: {
      paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0,
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/React.createElement(StatusBar, _extends({}, props, {
    backgroundColor: backgroundColor,
    style: {
      backgroundColor: backgroundColor
    }
  })));
};
const Layout = ({
  children
}) => {
  const theme = useTheme();
  const pathname = usePathname();
  const dispatch = useDispatch();
  const sidebar = useSelector(state => state.sidebar);
  const [, forceRender] = useState({});
  useEffect(() => {
    if (window.addEventListener) {
      window.addEventListener('resize', resize);
    }
    return () => {
      if (window.removeEventListener) {
        window.removeEventListener('resize', resize);
      }
    };
  }, []);
  const resize = async () => {
    forceRender({});
  };
  const isArticlePath = pathname?.includes('article');
  const slug = isArticlePath ? pathname.split('/').pop() : null;
  const {
    data: article,
    isLoading
  } = useGetArticleBySlugQuery(slug, {
    skip: !isArticlePath
  });
  if (isArticlePath && Platform.OS !== 'web') {
    return /*#__PURE__*/React.createElement(NativeDefault, {
      menu: /*#__PURE__*/React.createElement(Menu, null),
      footer: /*#__PURE__*/React.createElement(XStack, {
        bg: theme.warmGray.get(),
        borderColor: theme.borderGray.get(),
        borderStyle: "solid",
        borderTopWidth: 1,
        justifyContent: "space-around",
        zIndex: 999
      }, isLoading ? /*#__PURE__*/React.createElement(LoadingIndicator, null) : /*#__PURE__*/React.createElement(ArticleControls, {
        article: article
      }))
    }, children);
  } else if (Platform.OS !== 'web') {
    return /*#__PURE__*/React.createElement(NativeDefault, {
      footer: /*#__PURE__*/React.createElement(Footer, null)
    }, children);
  } else if (Platform.OS === 'web') {
    return /*#__PURE__*/React.createElement(WebDefault, null, children);
  }
  return /*#__PURE__*/React.createElement(Stack, null, children);
};
const NativeDefault = ({
  children,
  footer,
  menu
}) => {
  const dispatch = useDispatch();
  const sidebar = useSelector(state => state.sidebar);
  const theme = useTheme();
  const bg = useColorModeValue('#f4f4f5', '#3f3f46');
  const barTitle = useColorModeValue('dark-content', 'light-content');
  return /*#__PURE__*/React.createElement(SideMenu, {
    menu: menu || /*#__PURE__*/React.createElement(Menu, null),
    isOpen: sidebar,
    onChange: isOpen => dispatch(openSideBar(isOpen)),
    style: {
      flex: 12
    }
  }, /*#__PURE__*/React.createElement(GeneralStatusBarColor, {
    backgroundColor: bg,
    height: 0,
    barStyle: barTitle
  }), /*#__PURE__*/React.createElement(SafeAreaView, {
    style: {
      flex: 12,
      backgroundColor: '#eee'
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: 12
  }, /*#__PURE__*/React.createElement(Header, null), children)), /*#__PURE__*/React.createElement(Flex, {
    flex: Platform.OS === 'android' ? 1 : 1.25,
    zIndex: 999,
    bg: theme.warmGray.get()
  }, footer));
};
const WebDefault = ({
  children
}) => {
  const [isClient, setIsClient] = useState(false);
  const dispatch = useDispatch();
  const sidebar = useSelector(state => state.sidebar);
  useEffect(() => {
    setIsClient(true);
    return () => {
      setIsClient(false);
    };
  }, []);
  return isClient ? /*#__PURE__*/React.createElement(Stack, {
    nativeID: "sidebar-wrapper",
    height: "100%"
  }, /*#__PURE__*/React.createElement(SideMenu, {
    menu: /*#__PURE__*/React.createElement(Menu, null),
    isOpen: sidebar,
    onChange: isOpen => dispatch(openSideBar(isOpen)),
    disableGestures: true
  }, /*#__PURE__*/React.createElement(Flex, {
    flex: 12,
    bg: "white"
  }, /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 1
  }, children), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Footer, null))))) : /*#__PURE__*/React.createElement(Flex, {
    flex: 12,
    bg: "white"
  }, /*#__PURE__*/React.createElement(Header, null), /*#__PURE__*/React.createElement(Flex, {
    flexGrow: 1
  }, children), /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Footer, null)));
};
const LoadingIndicator = () => /*#__PURE__*/React.createElement(Loading, null);
export default Layout;